document.querySelectorAll('.pdp-acc-item').forEach((item) => {
  const clamp = item.querySelector('[data-acc-content-clamp]');
  const button = item.querySelector('[data-acc-show-more]');
  const details = item.querySelector('.pdp-acc-details');
  if (!clamp || !button) return;

  const showMoreLabel = button.dataset.labelMore;
  const showLessLabel = button.dataset.labelLess;

  const checkOverflow = () => {
    const isExpanded = clamp.classList.contains('pdp-acc-content-expanded');
    if (isExpanded) return;
    const isOverflowing = clamp.scrollHeight > clamp.clientHeight + 1;
    button.hidden = !isOverflowing;
  };

  button.addEventListener('click', () => {
    const isExpanded = clamp.classList.toggle('pdp-acc-content-expanded');
    button.textContent = isExpanded ? showLessLabel : showMoreLabel;
    button.setAttribute('aria-expanded', isExpanded);
  });

  if (details) {
    details.addEventListener('toggle', () => {
      if (details.open) requestAnimationFrame(checkOverflow);
    });
  }

  requestAnimationFrame(checkOverflow);
  window.addEventListener('resize', checkOverflow);
});
